<script>
import Layout from "../../../layouts/manage";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Dashboard",
      items: [""]
    };
  },
  mounted() {},
};
</script>

<template>
  <Layout>
    <PageHeader :title="$t('report.text')" :items="items" />
    <div class="row">

      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <!-- <h4 class="report-title mb-4">
              <i class="bx bx-card font-size-20 align-middle me-2"></i>
              {{$t('report.payment.text')}}
            </h4> -->
            <div class="card-text mb-2">
                <router-link :to="'report/service'">របាយការណ៍សេវាកម្ម និងទឹកភ្លើង</router-link>
            </div>
            <div class="card-text mb-2">
                <router-link :to="'report/debt-amount-summary'">របាយការណ៍ជំពាក់សរុប</router-link>
            </div>
            <div class="card-text mb-2">
                <router-link :to="'report/debt-amount'">របាយការណ៍ជំពាក់</router-link>
            </div>
            <div class="card-text mb-2">
                <router-link :to="'report/income-expense'">របាយការណ៍ចំណូល និងចំណាយ</router-link>
            </div>
          </div>
        </div>
      </div>

    </div>
  </Layout>
</template>
